'use client';
import { jsx } from 'react/jsx-runtime';
import { ProfileImage } from './profile-image.js';

const ProfileImageStack = ({ className, profiles, outlineColorClass = 'outline-white', }) => {
    return (jsx("div", { className: `flex items-center justify-center ${className}`, children: profiles.map((profile, idx) => (jsx(ProfileImage, { className: `relative -ml-2 inline-block size-5 shrink-0 rounded-full object-cover outline outline-1 first:ml-0 ${outlineColorClass}`, ...profile }, idx))) }));
};

export { ProfileImageStack };
//# sourceMappingURL=profile-image-stack.js.map
